"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _pie = require("@nivo/pie");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_pie.ResponsivePie, _extends({
    data: [],
    colors: {
      scheme: 'pastel2'
    },
    margin: {
      top: 50,
      right: 50,
      bottom: 65,
      left: 50
    },
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 3,
    borderWidth: 1,
    borderColor: {
      from: 'color',
      modifiers: [['darker', 0.2]]
    },
    arcLabelsSkipAngle: 10,
    arcLinkLabelsSkipAngle: 20,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    legends: [{
      anchor: 'bottom',
      direction: 'row',
      translateY: 56,
      translateX: 25,
      itemWidth: 100,
      itemHeight: 18,
      itemTextColor: '#999',
      symbolSize: 18,
      symbolShape: 'circle',
      effects: [{
        on: 'hover',
        style: {
          itemTextColor: '#000'
        }
      }]
    }]
  }, props));
};